import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import moment from "moment";

function CensusHistory({ show, setShow, rule, ruleHistory }) {
  const navigate = useNavigate();
  function findDifferences(obj1, obj2) {
    const differences = [];

    // Helper function to recursively compare objects
    function compareObjects(obj1, obj2, path = "") {
      // If objects are the same, no need to compare
      if (obj1 === obj2) return;

      // If either is null/undefined but not both
      if (
        obj1 === null ||
        obj2 === null ||
        obj1 === undefined ||
        obj2 === undefined
      ) {
        differences.push({
          path: path || "root",
          oldValue: obj1,
          newValue: obj2,
          type: "undefined",
        });
        return;
      }

      // If types are different
      if (typeof obj1 !== typeof obj2) {
        differences.push({
          path: path || "root",
          oldValue: obj1,
          newValue: obj2,
          type: "Different Obj Types",
        });
        return;
      }

      // If not objects (primitives), compare directly
      if (typeof obj1 !== "object" || typeof obj2 !== "object") {
        if (obj1 !== obj2) {
          differences.push({
            path: path || "root",
            modality:
              rule.configuration.modalities[
                parseInt(
                  path.split(".")[0].replace("modalities[", "").replace("]", "")
                )
              ]?.name,
            ages: `min: ${
              rule.configuration.modalities[
                parseInt(
                  path.split(".")[0].replace("modalities[", "").replace("]", "")
                )
              ]?.ages[
                parseInt(
                  path.split(".")[1].replace("ages[", "").replace("]", "")
                )
              ]?.ageMin
            } max:${
              rule.configuration.modalities[
                parseInt(
                  path.split(".")[0].replace("modalities[", "").replace("]", "")
                )
              ]?.ages[
                parseInt(
                  path.split(".")[1].replace("ages[", "").replace("]", "")
                )
              ]?.ageMax
            }`,
            oldValue: obj1,
            newValue: obj2,
          });
        }
        return;
      }

      // Handle arrays
      if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) {
          differences.push({
            path: path || "root",
            oldValue: obj1,
            newValue: obj2,
            type: "array",
          });
          return;
        }

        // Compare each element in the array
        for (let i = 0; i < obj1.length; i++) {
          compareObjects(obj1[i], obj2[i], `${path}[${i}]`);
        }
        return;
      }

      // Handle regular objects (not arrays)
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      // Check for keys only in obj1
      for (const key of keys1) {
        if (!keys2.includes(key)) {
          differences.push({
            path: path ? `${path}.${key}` : key,
            oldValue: obj1[key],
            newValue: undefined,
            type: "Key1",
          });
        }
      }

      // Check for keys only in obj2
      for (const key of keys2) {
        if (!keys1.includes(key)) {
          differences.push({
            path: path ? `${path}.${key}` : key,
            oldValue: undefined,
            newValue: obj2[key],
            type: "Key2",
          });
        }
      }

      // Check for shared keys with different values
      for (const key of keys1) {
        if (keys2.includes(key)) {
          compareObjects(obj1[key], obj2[key], path ? `${path}.${key}` : key);
        }
      }
    }

    compareObjects(obj1, obj2);
    // console.log("Differences", differences);
    return differences;
  }
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      animation={false}
      size="xl"
    >
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Census History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {ruleHistory?.map((history, index) => {
          return (
            <div key={index} className="rounded border border-dark p-1 mb-1">
              {index === 0 && <div className="text-muted">Rule Created</div>}
              <div className="row">
                <div className="col">
                  <div className="fw-bold">
                    {`Effective ${moment(history.effective).format(
                      "MMMM Do YYYY"
                    )}`}
                  </div>
                </div>
                <div className="col">
                  {history.expiration && history.expiration !== "" && (
                    <div className="fw-bold">
                      {`Expiration ${moment(history.expiration).format(
                        "MMMM Do YYYY"
                      )}`}
                    </div>
                  )}
                </div>
                <div className="col">
                  <i
                    className="fas fa-circle-right fa-lg mt-4 me-2 text-primary float-end"
                    role="button"
                    onClick={() => {
                      setShow(false);
                      navigate(`/rev/rules/${history.id}`);
                    }}
                  ></i>
                </div>
              </div>
              <div className="text-primary mb-2">
                {`Modified By: ${history.modifiedByName}`}
              </div>
              {index > 0 &&
                findDifferences(
                  ruleHistory[index - 1].configuration,
                  ruleHistory[index].configuration
                ).map((diff, diffIndex) => {
                  return (
                    <div key={diffIndex} className="row">
                      <div className="col">{diff.modality}</div>
                      <div className="col">{`Ages ${diff.ages}`}</div>
                      <div className="col">{diff.path.split(".")[2]}</div>
                      <div className="col text-danger">
                        {typeof diff.oldValue !== "object"
                          ? diff.oldValue
                          : JSON.stringify(diff.oldValue)}
                      </div>
                      <div className="col text-success">
                        {typeof diff.newValue !== "object"
                          ? diff.newValue
                          : JSON.stringify(diff.newValue)}
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-danger" onClick={() => setShow(false)}>
          Close
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CensusHistory;
